<mat-card class="flex flex-col gap-3">
  <div class="flex flex-row">
    <mat-card-title>Print Compliance PDF</mat-card-title>
    <span class="flex-1"></span>
    <button type="button" mat-flat-button color="warn" (click)="cancel()">Close</button>
  </div>
  <div class="flex flex-row">
    <mat-card-content>
      <div class="flex flex-col gap-4">
        <span style="font-size: 16px;">Enter Reporting Window start and end dates (4/1-4/25; 7/1-7/25; 10/1-10/25; 1/1-1/25) and a
          service center license number to generate a compliance PDF for a particular service center for a particular reporting period.
          This pdf will include a summary of the service center's 303 reporting history with detailed information about the specific quarter selected. </span>
      </div>
    </mat-card-content>
  </div>
  <div class="flex flex-row w-[100%]">
    <form [formGroup]="printPdfForm" class="flex gap-4 w-[100%] items-center">
      <mat-form-field class="max-md:w-[100%]">
        <mat-label>Begin</mat-label>
        <input placeholder="mm/dd/yyyy" formControlName="from" matInput [matDatepicker]="from" />
        <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
        <mat-datepicker #from>
          <mat-datepicker-actions>
            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
            <button mat-button matDatepickerCancel>Cancel</button>
          </mat-datepicker-actions>
        </mat-datepicker>
        <mat-error *ngIf="printPdfForm.get('from').hasError('required')">
          Begin date is required
        </mat-error>
      </mat-form-field>

      <mat-form-field class="max-md:w-[100%]">
        <mat-label>End</mat-label>
        <input placeholder="mm/dd/yyyy" formControlName="to" matInput [matDatepicker]="to" />
        <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
        <mat-datepicker #to>
          <mat-datepicker-actions>
            <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
            <button mat-button matDatepickerCancel>Cancel</button>
          </mat-datepicker-actions>
        </mat-datepicker>
        <mat-error *ngIf="printPdfForm.get('to').hasError('required')">
          End date is required
        </mat-error>
      </mat-form-field>

      <mat-form-field class="w-[30%]">
        <mat-label>License Id</mat-label>
        <input matInput type="text" formControlName="licenseId" placeholder="License Id">
        <mat-error *ngIf="printPdfForm.get('licenseId').hasError('required')">
          License Id is required
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  <div class="flex flex-row justify-center items-center">
    <button type="button" mat-flat-button color="primary" (click)="createReport()" [disabled]="!printPdfForm.valid || isCreatingReport">
      {{ isCreatingReport ? 'Generating PDF...' : 'Generate PDF' }}
    </button>
  </div>
</mat-card>
